import { Routes, Route } from 'react-router-dom'
import { JMAPAuthProvider } from './hooks/useJMAPAuth'
import { MailAdminAuthProvider } from './hooks/useMailAdminAuth'
import { AppShell } from './components/AppShell'
import { Dashboard } from './pages/Dashboard'
import Mail from './pages/Mail'
import { ComingSoon } from './pages/ComingSoon'
import { AdminLogin } from './pages/admin/Login'
import { Domains } from './pages/admin/Domains'
import { DomainDetail } from './pages/admin/DomainDetail'

export default function App() {
  return (
    <MailAdminAuthProvider>
      <JMAPAuthProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/mail" element={<Mail />} />
            <Route path="/calendar" element={<ComingSoon title="Calendar" description="Your schedule, private and synced via CalDAV." icon="📅" />} />
            <Route path="/contacts" element={<ComingSoon title="Contacts" description="Your address book, synced via CardDAV." icon="👤" />} />
            <Route path="/files" element={<ComingSoon title="Files" description="Encrypted file storage via WebDAV." icon="📁" />} />
            <Route path="/whiteboard" element={<ComingSoon title="Whiteboard" description="Visual collaboration." icon="🎨" />} />
            <Route path="/chat" element={<ComingSoon title="Chat" description="E2EE team messaging via Matrix." icon="💬" />} />
            <Route path="/video" element={<ComingSoon title="Video" description="E2EE voice and video calls via LiveKit." icon="🎥" />} />
            <Route path="/settings" element={<ComingSoon title="Settings" description="Manage your account and preferences." icon="⚙️" />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/domains" element={<Domains />} />
          <Route path="/admin/domains/:id" element={<DomainDetail />} />
        </Routes>
      </JMAPAuthProvider>
    </MailAdminAuthProvider>
  )
}
